function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProximalLogoSimple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-280.306 -55.117 635.209 615.745",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.1, 0, 0, -0.1, -171.28476, 558.040955)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M485 6109 c-202 -26 -351 -162 -421 -384 -135 -426 -16 -1165 321 -2005 111 -278 177 -422 320 -705 726 -1434 1798 -2655 2585 -2945 573 -211 909 147 850 905 -118 1524 -1542 3954 -2840 4847 -309 213 -600 315 -815 287z m405 -134 c448 -144 1030 -660 1586 -1408 691 -926 1235 -2057 1403 -2912 43 -219 54 -348 49 -552 -5 -155 -9 -189 -32 -268 -15 -49 -41 -115 -58 -147 -39 -73 -121 -151 -195 -186 -54 -25 -67 -27 -188 -26 -115 0 -140 3 -215 28 -270 90 -564 293 -904 626 -558 546 -1078 1278 -1496 2105 -730 1444 -851 2622 -283 2765 72 18 240 5 333 -25z",
    style: {
      fill: "rgb(248, 249, 250)",
      stroke: "rgb(248, 249, 250)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M -37.548 226.103 C -25.248 185.263 17.832 162.123 58.672 174.423 C 99.512 186.723 122.652 229.803 110.352 270.643 C 98.052 311.483 54.972 334.623 14.132 322.323 C -26.708 310.023 -49.848 266.943 -37.548 226.103 Z",
    strokeWidth: 4.58333,
    strokeMiterlimit: 8,
    fillRule: "evenodd",
    style: {
      fill: "rgb(248, 249, 250)",
      stroke: "rgb(248, 249, 250)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 150.732 81.683 L 63.112 163.753 L 35.382 46.943 L 150.732 81.683 Z",
    strokeWidth: 4.58333,
    strokeMiterlimit: 8,
    fillRule: "evenodd",
    style: {
      fill: "rgb(248, 249, 250)",
      stroke: "rgb(248, 249, 250)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -74.018 415.183 L 13.952 333.483 L 41.192 450.403 L -74.018 415.183 Z",
    strokeWidth: 4.58333,
    strokeMiterlimit: 8,
    fillRule: "evenodd",
    style: {
      fill: "rgb(248, 249, 250)",
      stroke: "rgb(248, 249, 250)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProximalLogoSimple);
export default __webpack_public_path__ + "static/media/proximal_logo_simple.0a610b743bb1bb89333a61cee2ee20f0.svg";
export { ForwardRef as ReactComponent };